import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import { dispatch } from "../../../../../state/store";
import { setFWUVersions, setFWUVersionToEdit } from "../../../../../state/ducks";

import { strCode } from "../../../../../consts";
import { log, notificationService, t } from "../../../../../services";
import { fwuVersionsUtil } from "../../../../../utils";

import {
  FlexContainers,
  SVG,
  TextButton,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../../../components";
import { FileUploadError } from "./FileUploadError";
import { FileInputTitleWrapper } from "../../styled";
import { FileUploadWrapper } from "../styled";

const BinFile = ({ fwuVersion, isNewRow }) => {
  const firmwares = useSelector((store) => store.fwuVersions.fwuVersions);
  const fwuVersionToEdit = useSelector((state) => state.fwuVersions?.fwuVersionToEdit);
  const loadingChanges = useSelector((state) => state.fwuVersions?.loadingChanges);

  const isEditing = fwuVersionsUtil.isVersionToEdit(fwuVersion);

  const [selectedFileName, setSelectedFileName] = useState("");

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!isNewRow && !isEditing && selectedFileName) {
      setSelectedFileName("");
      fileInputRef.current.value = "";
    }
  }, [isNewRow, isEditing, selectedFileName]);

  const handleFileInputClick = (event) => {
    event.stopPropagation();
    
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    if (!file.name.endsWith(".bin")) {
      log.warn("BinFile: Invalid bin file extension. " + file.name);
      notificationService.showError({
        title: t(strCode.INVALID_BIN_FILE_TITLE),
        message: t(strCode.INVALID_BIN_FILE_DESCRIPTION)
      });

      return;
    }

    setSelectedFileName(file.name);

    if (!isNewRow) {
      if (fwuVersionToEdit && isEditing) {
        dispatch(setFWUVersionToEdit({ ...fwuVersionToEdit, binFile: file }));
      } else {
        dispatch(setFWUVersionToEdit({ ...fwuVersion, binFile: file }));
        dispatch(setFWUVersions(firmwares.filter((firmware) => !firmware.isNew)));
      }
    } else {
      dispatch(
        setFWUVersions([
          ...firmwares.map((firmware) => {
            return firmware.isNew ? { ...firmware, binFile: file } : firmware;
          })
        ])
      );
    }
  };

  return (
    <FileUploadWrapper isNewRow={isNewRow} Container={FlexContainers.FlexColumnStart}>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept=".bin"
        onClick={(e) => e.stopPropagation()}
        onChange={handleFileChange}
      />

      {isNewRow && (
        <FileInputTitleWrapper style={{ fontSize: "14px" }}>
          {t(strCode.BIN_FILE_TITLE)}
        </FileInputTitleWrapper>
      )}

      <TextButton onClick={handleFileInputClick} disabled={loadingChanges}>
        <WrapperContainer Container={FlexContainers.FlexRow} gap={8}>
          {!isNewRow && !selectedFileName ? <FileUploadError /> : <SVG.FileIcon />}

          <TextOverflowWrapper maxWidth="116px">
            {selectedFileName ? selectedFileName : t(strCode.NO_FILE_CHOSEN)}
          </TextOverflowWrapper>
          <SVG.UploadIcon />
        </WrapperContainer>
      </TextButton>
    </FileUploadWrapper>
  );
};

BinFile.propTypes = {
  fwuVersion: PropTypes.object.isRequired,
  isNewRow: PropTypes.bool.isRequired
};

export default BinFile;
